import { useSelector, useDispatch } from 'react-redux';
import { setConfig, clearConfig } from '../store/configSlice';

export const useConfig = () => {
  const dispatch = useDispatch();
  const { config, loading, error } = useSelector((state) => state.config);

  const updateConfig = (newConfig) => {
    dispatch(setConfig(newConfig));
  };

  const removeConfig = () => {
    dispatch(clearConfig());
  };

  return {
    config,
    loading,
    error,
    updateConfig,
    removeConfig,
  };
}; 